export default __webpack_public_path__ + "images/6dfe2a92b78c03a9485e5073f7cdbf05-facebook_logo.svg";